
export const appkey = 'easemob-demo#chatdemoui'
export const version = '2.1.0' 
